import logoIdeal from 'assets/images/logoIdeal.png';
import logoCSystems from 'assets/images/logoCSystems.png';
import useAuth from 'hooks/useAuth';
import { Everest } from 'common/constants';

// ==========================|| IDEAL LOGO ICON PNG ||============================== //

export const LogoIcon = () => {
  const { user } = useAuth();
  const isIdeal = user?.dmsCompany.toLowerCase() === Everest.DMS_IDEAL_STR.toLowerCase();

  const favicon = document.getElementById("favicon") as HTMLLinkElement;
  if (favicon)
    favicon.href = isIdeal ? '/ideal.ico' : '/csystems.ico';

  if (isIdeal)
    return <img src={logoIdeal} alt="Price Lists Portal" width="50" height="auto" />;
  else
    return <img src={logoCSystems} alt="Price Lists Portal" width="50" height="auto" />;
};